import { useEffect } from 'react';
import { MIRAKL_PAGE } from '@noths/polaris-client-mirakl-tracking';
import {
  onMiraklConsentGranted,
  sendMiraklViewBeacon,
} from '@noths/polaris-client-mirakl-tracking/browser';
import { getProductIdFromProductCode } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';

/**
 * Posts the Mirakl `view` for this product to our own beacon route once the page is on screen.
 *
 * The product page HTML is edge cached, so nothing rendered into it can be trusted to describe the
 * current visitor. The body therefore carries only the product; the route reads consent and robot
 * status from the beacon request itself. A visitor who accepts advertising cookies on this page
 * sends the view again, since the first one was skipped for lack of consent.
 */
export const MiraklViewBeacon = ({ productCode }: { productCode: number }) => {
  useEffect(() => {
    const send = () =>
      sendMiraklViewBeacon(PUBLIC_API_BASE_PATH, {
        pageId: MIRAKL_PAGE.PDP,
        productId: getProductIdFromProductCode(productCode),
        referer: document.referrer,
        url: window.location.href,
      });

    send();

    return onMiraklConsentGranted(send);
  }, [productCode]);

  return null;
};
